import { Component, Inject, OnDestroy, Optional, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { StartupService } from '@core';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { DA_SERVICE_TOKEN, ITokenService, SocialOpenType, SocialService } from '@delon/auth';
import { SettingsService, _HttpClient } from '@delon/theme';
import { environment } from '@env/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTabChangeEvent } from 'ng-zorro-antd/tabs';
import { AccountService } from 'src/app/modules/service/account/account.service';
import { CommonService } from 'src/app/modules/service/common/common.service';
import { LoginService } from 'src/app/modules/service/login/login.service';
import { SlideVerifyComponent } from '../../../modules/component/slide-verify/slide-verify.component';

@Component({
  selector: 'passport-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less'],
  providers: [SocialService],
})
export class UserLoginComponent implements OnDestroy {
  @ViewChild('slideVerifier1', { static: false }) slideVerifier1: SlideVerifyComponent;

  verifyShow = false;

  type = 2;
  // 短信验证码
  countFirst = 1;
  count = 0;
  interval$: any;
  mobileNote: number | any = '';
  verifyNote: any = '';
  // 账号密码
  mobile: number | any = '';
  password: any = '';
  verify: any = '';
  validate: object = {
    field: '',
    status: false,
    msg: '',
  };
  verifyData: object = {};
  pwdShowType: boolean = false; // 密码显示方式
  error_type: string = '';

  constructor(
    fb: FormBuilder,
    private router: Router,
    private settingsService: SettingsService,
    private socialService: SocialService,
    @Optional()
    @Inject(ReuseTabService)
    private reuseTabService: ReuseTabService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
    private startupSrv: StartupService,
    public http: _HttpClient,
    public msg: NzMessageService,
    private message: NzMessageService,
    private loginService: LoginService,
    private common: CommonService,
  ) {
    this.getVerify();
  }

  sureSlider(e: any): void {
    console.log(e);
    this.verifyShow = e.target;
    this.verifyNote = '';
  }

  // 短信验证码
  getCaptcha(): void {
    const mobileValidate = this.loginService.validate(this.mobileNote, 'mobile');
    this.validate['mobileNote'] = mobileValidate;
    if (!mobileValidate.status) {
      this.message.create('error', '手机号格式错误');
      return;
    }
    this.loginService
      .sendSms({
        mobile: this.mobileNote,
      })
      .then((res) => {
        this.countFirst++;
        this.count = 59;
        this.interval$ = setInterval(() => {
          this.count -= 1;
          if (this.count <= 0) {
            clearInterval(this.interval$);
          }
        }, 1000);
      });
  }

  // 账号密码
  /**
   * 获取验证码
   */
  getVerify(): void {
    this.loginService.getCaptcha().then((res) => {
      this.verifyData = { ...res };
    });
  }

  ngOnDestroy(): void {}

  login(): void {
    if (this.type == 1) {
      // 验证码登录
      const mobileValidate = this.loginService.validate(this.mobileNote, 'mobile');
      this.validate['mobileNote'] = mobileValidate;
      if (!mobileValidate.status) {
        this.message.create('error', '手机号格式错误');
        return;
      }
      if (this.verifyShow == false) {
        this.message.create('error', '请拖动滑块');
        return;
      }
      if (this.verifyNote == '') {
        this.message.create('error', '请输入短信验证码');
        return;
      }
      this.loginService
        .checkMobile({
          mobile: this.mobileNote,
          code: this.verifyNote,
        })
        .then((res) => {
          if (res.is_change) {
            sessionStorage.setItem('mobile_note', this.mobileNote);
            sessionStorage.setItem('check_key', res.key);
            this.router.navigateByUrl('/passport/password-set');
          } else {
            this.loginService
              .loginMobile({
                key: res.key,
              })
              .then((res1) => {
                this.tokenService.set({ token: res1['access_token'] });
                this.common.setCache('userInfo', res1);
                this.loginService.getMenuRoles().then((menu) => {
                  this.common.setCache('menuRole', menu);
                  this.router.navigate(['/home']).then();
                });
              });
          }
        });
    } else {
      // 密码登录
      const mobileValidate = this.loginService.validate(this.mobile, 'mobile');
      this.validate['mobile'] = mobileValidate;
      if (!mobileValidate.status) {
        this.message.create('error', '手机号格式错误');
        return;
      }
      const pwdValidate = this.loginService.validate(this.password, 'password');
      this.validate['password'] = pwdValidate;
      if (!pwdValidate.status) {
        this.message.create('error', '密码错误');
        return;
      }
      const token = this.tokenService.get();
      this.loginService
        .doLogin({
          mobile: this.mobile,
          password: this.password,
          captcha: this.verify,
          captcha_key: this.verifyData['key'],
        })
        .then((res) => {
          if (res.is_change) {
            sessionStorage.setItem('mobile_note', this.mobile);
            sessionStorage.setItem('check_key', res.key);
            this.router.navigateByUrl('/passport/password-set');
          } else {
            this.error_type = '';
            this.tokenService.set({ token: res['access_token'] });
            this.common.setCache('userInfo', res);
            this.loginService.getMenuRoles().then((menu) => {
              this.common.setCache('menuRole', menu);
              this.router.navigate(['/home']).then();
            });
          }
        });
      setTimeout(() => {
        this.getVerify();
      }, 400);
    }
  }

  wxLogin(): void {
    this.loginService.getWinxinQrcodeUrl({}).then((res) => {
      const url = res.url;
      window.open(url, '_blank');
    });
  }

  // 限制数字
  keyup(): void {
    if (this.mobileNote != '') {
      this.mobileNote = this.mobileNote.replace(/[^\d]/g, '');
    }
    if (this.verifyNote != '') {
      this.verifyNote = this.verifyNote.replace(/[^\d]/g, '');
    }
  }

  /**
   * 校验表单
   */
  checkForm(): boolean {
    if (this.type == 1) {
      if (this.mobileNote == '') {
        this.validate = { field: 'mobileNote', status: false, msg: '请输入手机号' };
        return false;
      }
      if (this.verifyNote == '') {
        this.validate = { field: 'verifyNote', status: false, msg: '请输入验证码' };
        return false;
      }
      this.validate = { field: '', status: true, msg: '' };
    } else {
      if (this.mobile == '') {
        this.validate = { field: 'mobile', status: false, msg: '请输入手机号' };
        return false;
      }
      if (this.password == '') {
        this.validate = { field: 'password', status: false, msg: '请输入密码' };
        return false;
      }
      if (this.verify == '') {
        this.validate = { field: 'verify', status: false, msg: '请输入验证码' };
        return false;
      }
      this.validate = { field: '', status: true, msg: '' };
    }
  }

  /**
   * 取消报错
   * @param field
   */
  changeError(field: any): void {
    if (this.error_type == field) {
      this.error_type = '';
    }
  }

  ngOnInit(): void {}
}
